import React from "react";

function Footer() {
  // Define the openWindow function or replace it with your actual logic
  const openWindow = (frameName, flag) => {
    // Your openWindow logic here
    console.log(`Open window called with: ${frameName}, ${flag}`);
  };

  return (
    <footer className="site-footer">
    </footer>
  );
}

export default Footer;
